export const itemHeight = 48